module.exports = __webpack_public_path__ + "img/SCC_DC.2f16927b.png";